import BtxSwitch from '../../../Forms/BtxSwitch';
import { Col, Collapse, Row } from 'reactstrap';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import PartnerSubOfferingList from './PartnerSubOfferingList';

const PartnerOfferingField = ({
    id = false,
    title = 'null',
    value = false,
    subOfferings = [],
    disabled = true,
    callBack = () => {},
}) => {
    const [collapsed, setCollapsed] = useState(true);
    const toggleCollapser = () => setCollapsed(!collapsed);
    const BitwerxOfferingHasActiveSubOfferings = disabled === false && (!!subOfferings.length && subOfferings.some(so => so.isEnabled));
    return (
        <div className="mb-2">
            <Row className="align-items-center">
                <Col>
                    {BitwerxOfferingHasActiveSubOfferings ? (
                        <Row>
                            <Col className='d-flex align-items-center border-bottom border-danger' title='To disable this Bitwerx Offering you will have to disable all Sub Offerings.'>
                                <FontAwesomeIcon icon={faInfoCircle} size='xs' style={{'margin-left': '-15px', color:"red"}} />
                                <CustomSwitch value={value} disabled={disabled} callBack={callBack} id={id} />
                            </Col>
                        </Row>
                    ) 
                    : (
                        <CustomSwitch
                            value={value}
                            disabled={disabled}
                            callBack={callBack}
                            id={id}
                        />
                    )}
                </Col>
                <Col>
                    <Row
                        onClick={toggleCollapser}
                        className="align-items-center justify-content-center">
                        <Col xs="6">{title}</Col>
                        <Col xs="6">
                            {subOfferings.length ? (
                                <FontAwesomeIcon
                                    icon={
                                        collapsed ? faChevronDown : faChevronUp
                                    }
                                />
                            ) : (<></>)}
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Collapse isOpen={!collapsed}>
                <PartnerSubOfferingList
                    subOfferings={subOfferings}
                    disabled={disabled}
                    callBack={callBack}
                />
            </Collapse>
        </div>
    );
};

const CustomSwitch = ({ value, disabled, callBack = () => {}, id }) => {
    const [switchState, setswitchState] = useState(value);
    const update = () => {
        callBack({ id: id, value: !switchState });
        setswitchState(!switchState);
    };
    return (
        <BtxSwitch value={switchState} disabled={disabled} onChange={update} />
    );
};

export default PartnerOfferingField;
